import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import store from './store'
import moment from 'moment'
import uniq from 'lodash/uniq'

Vue.prototype.$vuetify.theme = {
  primary: process.env.VUE_APP_COLOR_PRIMARY,
  secondary: process.env.VUE_APP_COLOR_SECONDARY,
  accent: process.env.VUE_APP_COLOR_ACCENT,
  error: '#f44336',
  warning: '#ffeb3b',
  info: '#2196f3',
  success: '#4caf50'
}

axios.defaults.headers.common['X-API-KEY'] = '589273452743985'

const token = localStorage.getItem('user-token')
if (token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

Vue.config.productionTip = false

moment.locale('us')

window.$ = window.jQuery = require('jquery')

Vue.mixin({
  methods: {
    isFloat: function (x) {
      if (Number.isInteger(x) === true) {
        return true
      } else {
        return !!(x % 1)
      }
    },
    removeFileExtension: function (filename) {
      return filename.substr(0, filename.lastIndexOf('.'))
    },
    generatePermalink: function (text) {
      return text.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace('--', '-').replace('-', ' ')
    },
    getStaticMapUrl: function (latitude, longitude, width = 300, height = 300, zoom = 16) {
      return 'https://maps.googleapis.com/maps/api/staticmap?center=' + latitude + ',' + longitude + '&zoom=' + zoom + '&size=' + width + 'x' + height + '&maptype=roadmap&markers=color:red%7Clabel:%7C' + latitude + ',' + longitude + '&key=' + process.env.VUE_APP_GOOGLE_API_KEY
    },
    copyToClipbpard: function (text) {
      var textArea = document.createElement('textarea')
      textArea.value = text
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('Copy')
      textArea.remove()
    },
    selectTextInElement: function (element) {
      var el = document.getElementById(element)
      var range = document.createRange()
      range.selectNodeContents(el)
      var sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
    },
    highlightKeywords: function (text, keywords, minKeywordLength = 3) {
      keywords = keywords.replace('  ', ' ')
      var keywordArray = uniq(keywords.split(' '))
      console.log(keywordArray)
      for (var i in keywordArray) {
        var keyword = keywordArray[i].trim()
        if (keyword.length >= minKeywordLength) {
          var pattern = new RegExp('(' + keyword + ')', 'gi')
          text = text.replace(pattern, '<mark>' + keyword + '</mark>')
        }
      }
      return text
    },
    disableBottomDetector: function () {
      window.onscroll = () => {
      }
    },
    getUserProfile: function () {
      return JSON.parse(localStorage.getItem('user-profile'))
    },
    checkPermission: function (profile, permissionId, action) {
      if (profile && profile.permissions) {
        for (var i in profile.permissions) {
          if (this.profile.permissions[i].permissionId === permissionId) {
            if (this.profile.permissions[i]['is' + this.capitalize(action)] === '1') {
              return true
            }
          }
        }
      }
      return false
    },
    br2nl: function (str) {
      return str.replace(/<br\s*\/?>/mg, '\n')
    },
    formatPrice: function (price, digit = 2, decimalSign = '.') {
      var formatter
      if (decimalSign === ',') {
        formatter = new Intl.NumberFormat('id-ID', {
          minimumFractionDigits: digit,
          maximumFractionDigits: digit
        })
      } else {
        formatter = new Intl.NumberFormat('us-US', {
          minimumFractionDigits: digit,
          maximumFractionDigits: digit
        })
      }

      return formatter.format(price)
    },
    roundToDecimal: function (num, decimal = 2) {
      var coefficient = Math.pow(10, decimal)
      return Math.round(num * coefficient) / coefficient
    },
    openDrawerForDesktop: function () {
      var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      // var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight

      if (width > 960) {
        this.drawer = true
      }
    },
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      value = value.toLowerCase()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    deepCopy: function (o) {
      var output, v, key
      output = Array.isArray(o) ? [] : {}
      for (key in o) {
        v = o[key]
        output[key] = (typeof v === 'object') ? this.deepCopy(v) : v
      }
      return output
    },
    showAlert: function (error) {
      if (error.response.status === 403) {
        window.alert('Sorry, you have no access to this function: ' + error.response.data.message)
      } else {
        window.alert(error.response.data.message)
      }
    },
    iso8601Format: function () {
      return 'YYYY-MM-DDTHH:mm:ssZ'
    },
    updateUrl: function (newUrl) {
      window.history.pushState({ path: newUrl }, '', newUrl)
    },
    forceUpdate: function () {
      this.$forceUpdate()
    },
    delay: function (ms) {
      ms += new Date().getTime()
      while (new Date() < ms) {}
    },
    goBack: function () {
      router.go(-1)
    }
  },
  filters: {
    allCaps: function (string) {
      if (string !== null && typeof string !== 'undefined') {
        return string.toUpperCase()
      }
    },
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      value = value.toLowerCase()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    truncate: function (string, value) {
      if (string.length > value) {
        return string.substring(0, value) + '...'
      }
      return string
    },
    formatDate: function (value, format, timezone = '') {
      moment.locale('us')
      if (typeof value !== 'undefined') {
        if (value.length > 0) {
          if (typeof timezone !== 'undefined' && timezone.length > 0) {
            if (timezone === '+00:00') {
              return moment(value, 'YYYY-MM-DDTHH:mm:ssZ').format(format) + ' (GMT)'
            } else {
              return moment(value, 'YYYY-MM-DDTHH:mm:ssZ').format(format) + ' (GMT ' + timezone + ')'
            }
          } else {
            return moment(value, 'YYYY-MM-DDTHH:mm:ssZ').format(format)
          }
        }
      }
      return ''
    }
  }
})

/*
  EventBus support these events
  - profileUpdated
*/
export const EventBus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
